import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { DigestionPartCreateForm } from "./components/DigestionPartCreateForm";

export function NewDigestionPartPage() {
  return (
    <Page title="New Digestion Part">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionPartCreateForm />
      </Container>
    </Page>
  );
}
